<template>
  <svg viewBox="0 0 25 25" width="25" height="25" role="presentation">
    <circle fill="#78D33D" cx="12.5" cy="12.5" r="12.5" />
    <path
      fill="none"
      stroke="#fff"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M7 14.25L10.826 18 18 8"
    />
  </svg>
</template>

<style scoped>
path {
  stroke: var(--bg-color);
}
</style>
